import { ChevronRight, Search } from 'lucide-react';

import { Collapsible, CollapsibleContent, CollapsibleTrigger } from '@/app/ui/collapsible';

/**
 * A tool call as one readable line — "Counted 26 estimates by status" — that
 * opens to show what was asked and what came back.
 */
const ToolStep = ({ block }) => {
  return (
    <Collapsible className="group/step my-1.5" data-testid="agent-tool-step">
      <CollapsibleTrigger
        className="text-muted-foreground hover:text-foreground flex items-center gap-1.5 text-left text-xs transition-colors"
        data-testid="agent-tool-step-trigger"
      >
        <Search className="size-3.5 shrink-0" />
        <span>{block.title}</span>
        <ChevronRight className="size-3.5 shrink-0 transition-transform group-data-[state=open]/step:rotate-90" />
      </CollapsibleTrigger>
      <CollapsibleContent>
        <div className="bg-muted/50 mt-1.5 space-y-2 rounded-md border p-2 text-xs">
          <ToolStepDetail label="Asked" value={block.input} />
          <ToolStepDetail label="Found" value={block.output} />
        </div>
      </CollapsibleContent>
    </Collapsible>
  );
};

const ToolStepDetail = ({ label, value }) => (
  <div>
    <div className="text-muted-foreground mb-0.5 font-medium">{label}</div>
    <pre className="overflow-x-auto font-mono text-[11px] leading-4 whitespace-pre-wrap">{JSON.stringify(value, null, 2)}</pre>
  </div>
);

export default ToolStep;
